import { createAsyncThunk } from '@reduxjs/toolkit'
import MediaDescription from './media-description-model'
import {
  delete_mediaDescription,
  load_mediaDescriptions,
  store_mediaDescription,
} from './mediaDescription-service'

export const LoadMediaDescriptionsAsync = createAsyncThunk<any, any>(
  'composer/load/mediaDescription',
  async (params: { uid: string }) => {
    return await load_mediaDescriptions(params)
  },
)

export const CreateMediaDescriptionAsync = createAsyncThunk<any, any>(
  'composer/create/mediaDescription',
  async (params: MediaDescription) => {
    return await store_mediaDescription(params)
  },
)

export const DeleteMediaDescriptionAsync = createAsyncThunk<any, any>(
  'composer/delete/mediaDescription',
  async (params) => {
    return await delete_mediaDescription(params)
  },
)
